import { render, staticRenderFns } from "./modifyPhone.vue?vue&type=template&id=99493280&scoped=true&"
import script from "./modifyPhone.vue?vue&type=script&lang=js&"
export * from "./modifyPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99493280",
  null
  
)

export default component.exports